<template>
  <transition :name="`popup-${direction}`" @after-leave="handleAfterLeave">
    <div :class="[`popup-${direction}`]" v-if="currentValue"><slot/></div>
  </transition>
</template>

<script>
import PopupMixins from '@/utils/mixins/popup'
export default {
  name: 'jc-popup',
  mixins: [PopupMixins],
  props: {
    value: Boolean,
    direction: {
      type: String,
      default: 'top'
    },
    transition: {
      type: String,
      default: 'popup-slide-down'
    }
  },
  data () {
    return {
      currentValue: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.currentValue = this.value
      }
    },
    currentValue () {
      if (this.currentValue) {
        this.rendered = true
        this.open()
      }
      this.$emit('input', this.currentValue)
    }
  },
  methods: {
    handleAfterLeave () {
      this.handleLockScroll(true)
      this.$emit('closed')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/popup/index.vue